export const optionsBar = {
  title: '',
  legend: {
    position: 'none'
  },
  tooltip: {
    showColorCode: true
  },
  animation: {
    duration: 1500,
    easing: 'out',
    startup: true
  },
  vAxis: {
    textPosition: 'none'
  },
  hAxis: {
    viewWindowMode: 'maximized'
  },
  chartArea: {
    width: '90%',
    height: '90%'
  },
  bar: { groupWidth: '75%' },
  fontSize: 14,
  fontName: 'Roboto'
}

export const optionsBarTitles = {
  title: '',
  legend: {
    position: 'none'
  },
  tooltip: {
    showColorCode: true
  },
  animation: {
    duration: 1500,
    easing: 'out',
    startup: true
  },
  hAxis: {
    viewWindowMode: 'maximized'
  },
  chartArea: {
    width: '75%',
    height: '90%'
  },
  bar: { groupWidth: '75%' },
  fontSize: 14,
  fontName: 'Roboto'
}

export const optionsVerticalBar = {
  title: '',
  bars: 'vertical',
  legend: {
    position: 'none'
  },
  tooltip: {
    showColorCode: true
  },
  animation: {
    duration: 1500,
    easing: 'inAndOut',
    startup: true
  },
  vAxis: {
    viewWindowMode: 'maximized'
  },
  hAxis: {
    viewWindowMode: 'maximized'
  },
  chartArea: {
    width: '90%',
    height: '80%'
  },
  bar: { groupWidth: '85%', width: '90%' },
  fontSize: 20,
  fontName: 'Roboto'
}

export const optionsStackedBar = {
  title: '',
  legend: {
    position: 'none'
  },
  tooltip: {
    showColorCode: true
  },
  isStacked: true,
  animation: {
    duration: 1500,
    easing: 'out',
    startup: true
  },
  vAxis: {
    textPosition: 'none',
    viewWindowMode: 'maximized'
  },
  hAxis: {
    viewWindowMode: 'maximized'
  },
  chartArea: {
    width: '90%',
    height: '90%'
  },
  bar: { groupWidth: '80%' },
  fontSize: 14,
  fontName: 'Roboto'
}

export const optionsCombo = {
  title: '',
  seriesType: 'bars',
  legend: {
    position: 'top'
  },
  series: { 1: { type: 'line', color: '#6D4C41', lineWidth: 4, lineDashStyle: [4, 1] },
    2: { type: 'line', color: '#FF0000', lineWidth: 4, lineDashStyle: [8, 3] },
    3: { type: 'line', color: '#000000', lineWidth: 4, lineDashStyle: [10, 2] } },
  vAxis: { viewWindowMode: 'maximized' },
  animation: {
    duration: 1000,
    easing: 'inAndOut',
    startup: true
  },
  chartArea: {
    width: '80%',
    height: '80%'
  }
}

export const optionsStackedVerticalBar = {
  title: '',
  legend: {
    position: 'none'
  },
  tooltip: {
    showColorCode: true
  },
  isStacked: true,
  animation: {
    duration: 1500,
    easing: 'out',
    startup: true
  },
  chartArea: {
    width: '90%',
    height: '90%'
  },
  bar: { groupWidth: '75%' },
  fontSize: 14,
  fontName: 'Roboto'
}

export const optionsStackedVerticalBarCalado = {
  title: '',
  width: '200px',
  height: '90px',
  legend: {
    position: 'none'
  },
  tooltip: {
    showColorCode: true
  },
  isStacked: true,
  animation: {
    duration: 0,
    easing: 'in',
    startup: false
  },
  vAxis: {
    textPosition: 'none',
    viewWindowMode: 'maximized'
  },
  hAxis: {
    textPosition: 'center',
    viewWindowMode: 'maximized'
  },
  chartArea: {
    width: '90%',
    height: '90%'
  },
  annotations: {
    textStyle: {
      fontSize: 25,
      bold: true,
      textPosition: 'left',
      textAlignVertical: 'bottom'
    }
  },
  bar: { groupWidth: '80%' }
}

export const CallesCalado = {
  title: '',
  bars: 'vertical',
  legend: {
    position: 'none'
  },
  tooltip: {
    showColorCode: false,
    isHtml: true,
    textStyle: {
      fontSize: 12,
      bold: true
    }
  },
  animation: {
    duration: 1000,
    easing: 'inAndOut',
    startup: true
  },
  annotations: {
    textStyle: {
      fontSize: 14,
      bold: true,
      color: '#e0440e',
      auraColor: 'none'
    },
    alwaysOutside: false
  },
  yAxis: {
    fontSize: 14,
    direction: -1,
    viewWindowMode: 'maximized'
  },
  xAxis: {
    fontSize: 14,
    viewWindowMode: 'maximized',
    direction: -45
  },
  chartArea: {
    width: '100%',
    height: '100%'
  },
  isStacked: 'percent',
  bar: { groupWidth: '90%', width: '100%' },
  fontSize: 14,
  fontName: 'Roboto'
}

export const Histograma = {
  title: '',
  bars: 'vertical',
  legend: {
    position: 'none'
  },
  tooltip: {
    showColorCode: false,
    isHtml: true,
    textStyle: {
      fontSize: 12,
      bold: true
    }
  },
  animation: {
    duration: 1500,
    easing: 'inAndOut',
    startup: true
  },
  annotations: {
    textStyle: {
      fontSize: 14,
      bold: true,
      color: '#e0440e',
      auraColor: 'none'
    },
    alwaysOutside: false
  },
  vAxis: {
    viewWindowMode: 'maximized',
    minValue: 0
  },
  hAxis: {
    textPosition: 'out',
    viewWindowMode: 'maximized',
    ticks: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23]
  },
  chartArea: {
    width: '90%',
    height: '70%'
  },
  isStacked: 'true',
  bar: { groupWidth: '90%', width: '100%' },
  fontSize: 12,
  fontName: 'Roboto'
}
